import { FunctionComponent } from 'react'
import useStyles from './styles'
import { ConfirmationProfessionalReservationProps } from './types'
import { Text, Avatar } from '@conexasaude/conexa-hero'
import { capitalize } from '@/utils/fnUtils'
import DivisorLine from '@/components/DivisorLine'

const ConfirmationProfessionalReservation: FunctionComponent<
  ConfirmationProfessionalReservationProps
> = ({ photo, professionalName, professionalSpeciality }) => {
  const styles = useStyles()

  return (
    <div>
      <div css={styles.wrapperProfessionalSection}>
        <Avatar src={photo} size="large" />
        <div css={styles.wrapperText}>
          <Text variant="headingMedium">
            {professionalName
              ? capitalize(professionalName)
              : 'Aguardando definição'}
          </Text>
          <Text>{professionalSpeciality}</Text>
        </div>
      </div>
      <DivisorLine />
    </div>
  )
}

export default ConfirmationProfessionalReservation
